import { useMemo } from 'react';
import { useEventStore } from 'entities/event';
import { useGetMatchTypesByIds } from 'entities/match-type';

export const useMatchTypesForEvents = () => {
  const eventsMap = useEventStore(state => state.map);

  const matchTypeIds = useMemo(() => Array.from(eventsMap.values()).reduce((acc, cur) => {
    cur.eventTypeId &&
      !acc.includes(cur.eventTypeId) &&
      acc.push(cur.eventTypeId);

    return acc;
  }, [] as number[]), [eventsMap]);

  return useGetMatchTypesByIds(matchTypeIds);
};
